import React from 'react';
import Hero from './components/Hero';
import ProductOverview from './components/ProductOverview';
import SludgeDissolution from './components/SludgeDissolution';
import TrustExperience from './components/TrustExperience';
import HowItWorks from './components/HowItWorks';
import PerformanceResults from './components/PerformanceResults';
import KeyClients from './components/KeyClients';
import WhyChoose from './components/WhyChoose';
import CallToAction from './components/CallToAction';
import ContactSection from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div>
      <div
        className="app-background"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/hero.png)`,
        }}
      ></div>
      <Hero />
      <ProductOverview />
      <SludgeDissolution />
      <TrustExperience />
      <HowItWorks />
      <PerformanceResults />
      <KeyClients />
      <WhyChoose />
      <CallToAction />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default App;